import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AuthenticatedRoute from '../components/authenticated-route';
import IndexRoute from '../components/index-route';
import UnauthenticatedRoute from '../components/unauthenticated-route';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';

import { isServer } from '../../store';

import Error from './error';


const Homepage = Loadable({
  loader: () => import('./home'),
  loading: () => null,
});

const Login = Loadable({
  loader: () => import('./login'),
  loading: () => null,
});


const Logout = Loadable({
  loader: () => import('./logout'),
  loading: () => null,
});




const ActiveMaintenanceFullPage = Loadable({
    loader: () => import('../../pages/activeMaintenanceFullPage'),
    loading: () => null,
});

const ActiveMaintenanceSmallPage = Loadable({
    loader: () => import('../../pages/activeMaintenanceSmallPage'),
    loading: () => null,
});

const BillingAddressPage = Loadable({
    loader: () => import('../../pages/billingAddressPage'),
    loading: () => null,
});
const CardInfoPage = Loadable({
    loader: () => import('../../pages/cardInfoPage'),
    loading: () => null,
});
const ContinueTrialPage = Loadable({
    loader: () => import('../../pages/continueTrialPage'),
    loading: () => null,
});
const ExpiredContractFullPage = Loadable({
    loader: () => import('../../pages/expiredContractFullPage'),
    loading: () => null,
});
const ExpiredContractSmallPage = Loadable({
    loader: () => import('../../pages/expiredContractSmallPage'),
    loading: () => null,
});
const ExpiringContractFullPage = Loadable({
    loader: () => import('../../pages/expiringContractFullPage'),
    loading: () => null,
});
const ExpiringContractSmallPage = Loadable({
    loader: () => import('../../pages/expiringContractSmallPage'),
    loading: () => null,
});
const FreemiumPage = Loadable({
    loader: () => import('../../pages/freemiumPage'),
    loading: () => null,
});
const FreemiumOverMaxVersionPage = Loadable({
        loader: () => import('../../pages/freemiumOverMaxVersionPage'),
    loading: () => null,
});
const MaintenanceOptionsPage = Loadable({
    loader: () => import('../../pages/maintenanceOptionsPage'),
    loading: () => null,
});
const CouldNotStartMlaPage = Loadable({
        loader: () => import('../../pages/couldNotStartMlaPage'),
    loading: () => null,
});
const PaymentReviewPage = Loadable({
    loader: () => import('../../pages/paymentReviewPage'),
    loading: () => null,
});
const PaypalPage = Loadable({
    loader: () => import('../../pages/paypalPage'),
    loading: () => null,
});
const NetellerPage = Loadable({
        loader: () => import('../../pages/netellerPage'),
    loading: () => null,
});
const PurchaseCompleteSuccessPage = Loadable({
    loader: () => import('../../pages/purchaseCompleteSuccessPage'),
    loading: () => null,
});
const PurchasePage = Loadable({
    loader: () => import('../../pages/purchasePage'),
    loading: () => null,
});
const SelectProductsPage = Loadable({
    loader: () => import('../../pages/selectProductsPage'),
    loading: () => null,
});

const SelectHmAppsProductsPage = Loadable({
    loader: () => import('../../pages/selectHmAppsProductsPage'),
    loading: () => null,
});
const SelectHmAppVariantProductsPage = Loadable({
    loader: () => import('../../pages/selectHmAppVariantProductsPage'),
    loading: () => null,
});

const UpgradeProductsPage = Loadable({
        loader: () => import('../../pages/upgradeProductsPage'),
    loading: () => null,
});
const PreSelectProductsPage = Loadable({
        loader: () => import('../../pages/preSelectProductsPage'),
    loading: () => null,
});
const StartTrialOptionsPage = Loadable({
    loader: () => import('../../pages/startTrialOptionsPage'),
    loading: () => null,
});
const TrialLicensePage = Loadable({
    loader: () => import('../../pages/trialLicensePage'),
    loading: () => null,
});
const TrialStartedPage = Loadable({
    loader: () => import('../../pages/trialStartedPage'),
    loading: () => null,
});
const ViewMissedUpdatesPage = Loadable({
    loader: () => import('../../pages/viewMissedUpdatesPage'),
    loading: () => null,
});
const GetHm3ForFreePage = Loadable({
        loader: () => import('../../pages/getHm3ForFreePage'),
    loading: () => null,
});






export default () => {
    //log(LogCategory.info,"routing " + (isServer ? "server" : "client") );
    return (
  <Switch>
    <IndexRoute exact path="/" component={Homepage} />

    <Route exact path="/activeMaintenanceFullPage" component={ActiveMaintenanceFullPage} />
    <Route exact path="/activeMaintenanceSmallPage" component={ActiveMaintenanceSmallPage} />
    <Route exact path="/billingAddressPage" component={BillingAddressPage} />
    <Route exact path="/cardInfoPage" component={CardInfoPage} />
    <Route exact path="/continueTrialPage" component={ContinueTrialPage} />
    <Route exact path="/expiredContractFullPage" component={ExpiredContractFullPage} />
    <Route exact path="/expiredContractSmallPage" component={ExpiredContractSmallPage} />
    <Route exact path="/expiringContractSmallPage" component={ExpiringContractSmallPage} />
    <Route exact path="/expiringContractFullPage" component={ExpiringContractFullPage} />
    <Route exact path="/freemiumPage" component={FreemiumPage} />
    <Route exact path="/freemiumOverMaxVersionPage" component={FreemiumOverMaxVersionPage} />
    <Route exact path="/maintenanceOptionsPage" component={MaintenanceOptionsPage} />
    <Route exact path="/paymentReviewPage" component={PaymentReviewPage} />
    <Route exact path="/paypalPage" component={PaypalPage} />
    <Route exact path="/purchaseCompleteSuccessPage" component={PurchaseCompleteSuccessPage} />
    <Route exact path="/purchasePage" component={PurchasePage} />
    <Route exact path="/netellerPage" component={NetellerPage} />
    <Route exact path="/selectProductsPage" component={SelectProductsPage} />

    <Route exact path="/selectHmAppsProductsPage" component={SelectHmAppsProductsPage} />
    <Route exact path="/selectHmAppVariantProductsPage/:filter" component={SelectHmAppVariantProductsPage} />

    <Route exact path="/upgradeProductsPage" component={UpgradeProductsPage} />
    <Route exact path="/preSelectProductsPage" component={PreSelectProductsPage} />
    <Route exact path="/startTrialOptionsPage" component={StartTrialOptionsPage} />
    <Route exact path="/trialLicensePage" component={TrialLicensePage} />
    <Route exact path="/getHm3ForFreePage" component={GetHm3ForFreePage} />
    <Route exact path="/trialStartedPage" component={TrialStartedPage} />
    <Route exact path="/viewMissedUpdatesPage" component={ViewMissedUpdatesPage} />
    <Route exact path="/couldNotStartMlaPage" component={CouldNotStartMlaPage} />

    <Route component={Error} />
  </Switch>
)};




// WEBPACK FOOTER //
// ./src/app/routes/index.js